import { useRecruiting } from '../lib/recruiting';

const ST = {
  work:  { bg: '#E3F0FB', fg: '#1F5F9C' },
  pause: { bg: '#FFF1D6', fg: '#8A6100' },
  done:  { bg: '#DDF3E4', fg: '#276221' },
};

// Статус и этап подбора по маршруту из файла «Заявки подбора». Нет заявки — ничего не рисуем.
export default function RecruitChip({ routeId, style }) {
  const list = useRecruiting()[routeId];
  if (!list || !list.length) return null;
  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 2, alignItems: 'flex-start', ...style }}>
      {list.map((r, i) => {
        const k = r.status === 'Приостановлена' ? 'pause' : (r.stage === 'Принят' || r.stage === 'Оффер') ? 'done' : 'work';
        const c = ST[k];
        return (
          <span key={i} title={[r.vacancy_id && `Заявка ${r.vacancy_id}`, r.suspend_reason && `Причина приостановки: ${r.suspend_reason}`, r.recruiter && `Рекрутер: ${r.recruiter}`].filter(Boolean).join(' · ')}
            style={{ fontSize: 10, fontWeight: 700, padding: '1px 7px', borderRadius: 10, background: c.bg, color: c.fg, whiteSpace: 'nowrap' }}>
            {k === 'pause' ? '✗' : '✓'} Подбор: {r.status || '—'}{r.stage ? ` · ${r.stage}` : ''}{r.vacancy_id ? ` · №${r.vacancy_id}` : ''}
          </span>
        );
      })}
    </span>
  );
}
